export enum AppKeyTableStorageKeys {
	clusterFilter = 'clusterFilter',
	providerFilter = 'providerFilter'
}

export enum AppKeyTableActions {
	edit = 'edit',
	legals = 'legals',
	requiredVersions = 'requiredVersions'
}
